import { ListGroup } from "react-bootstrap"
import { ArticleView, SearchArticlesHighlights, SearchArticlesScores } from "../../models/article"
import { SearchResultsHeader } from "../SearchResultsHeader"
import { SearchQueryArticlesItem } from "./components/Item"

interface SearchQueryArticlesProps {
    articles: ArticleView[]
    highlights?: SearchArticlesHighlights
    scores?: SearchArticlesScores
    onArticleClick: (articleCode: string) => void
    isNotKB?: boolean
}

export const SearchQueryArticles = (props: SearchQueryArticlesProps) => {
    const { articles, highlights, onArticleClick, isNotKB = false } = props

    return (
        <div>
            <SearchResultsHeader itemCount={articles ? articles.length : 0} />

            {articles && articles.length > 0 && (
                <ListGroup variant="flush">
                    {articles.map(article => (
                        <ListGroup.Item key={article.Id}>
                            <SearchQueryArticlesItem
                                article={article}
                                highlights={highlights && highlights[article.Id]}
                                onArticleClick={onArticleClick}
                                isNotKB={isNotKB}
                            />
                        </ListGroup.Item>
                    ))}
                </ListGroup>
            )}
        </div>
    )
}
